var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({tag:"component",staticClass:"nav-item",attrs:{"tag":"li"}},'component',_vm.$attrs,false),[_c('a',{staticClass:"nav-link"},[_vm._t("default",function(){return [(_vm.img)?_c('img',{staticClass:"img_usuario_thumb",attrs:{"src":_vm.img}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.name))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }